import React, { FC } from 'react';
import { Driver } from '../../types/driver.types';

interface StatisticsProps {
  drivers: Driver[];
}

export const Statistics: FC<StatisticsProps> = ({ drivers }) => {
  const activeCount = drivers.filter(d => d.active).length;
  const inactiveCount = drivers.filter(d => !d.active).length;

  return (
    <div className="bg-white rounded-lg shadow-md p-4">
      <h2 className="text-xl font-semibold mb-4">Statistics</h2>
      <div className="space-y-2">
        <div className="flex justify-between">
          <span className="text-gray-600">Total Drivers:</span>
          <span className="font-semibold">{drivers.length}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Active Drivers:</span>
          <span className="font-semibold text-green-600">{activeCount}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Inactive Drivers:</span>
          <span className="font-semibold text-red-600">{inactiveCount}</span>
        </div>
      </div>
    </div>
  );
};